module.exports = __webpack_public_path__ + "static/media/mockup.4fd8dc3a.png";